import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';
import { Tag } from 'lucide-react';

export function PricingRulesEditor() {
  return (
    <Card>
      <CardHeader title="Règles de tarification" />
      <CardContent>
        <EmptyState
          message="Aucune règle de tarification"
          description="Les règles de remise volume et codes promo apparaîtront ici"
          icon={<Tag className="h-8 w-8" />}
        />
      </CardContent>
    </Card>
  );
}
